"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectVirtualized = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SelectParts_1 = require("./SelectParts");
const react_virtual_1 = require("@tanstack/react-virtual");
const SelectVirtualized = (props) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const scrollableElemRef = (0, react_1.useRef)(null);
    const virtualizer = (0, react_virtual_1.useVirtualizer)({
        enabled: isOpen,
        count: props.items.length,
        getScrollElement: () => scrollableElemRef.current,
        estimateSize: () => 40,
        overscan: 10,
    });
    const handleScrollElementRef = (0, react_1.useCallback)((element) => {
        scrollableElemRef.current = element;
        if (!isOpen || !element)
            return;
        virtualizer.measure();
        const selectedIndex = props.items.findIndex(item => item.value === props.value);
        if (selectedIndex !== -1) {
            requestAnimationFrame(() => {
                virtualizer.scrollToIndex(selectedIndex, {
                    align: 'start',
                });
            });
        }
    }, [isOpen, props.value, props.items, virtualizer]);
    const totalScrollElementHeight = virtualizer.getTotalSize();
    return ((0, jsx_runtime_1.jsxs)(SelectParts_1.Select, Object.assign({ open: isOpen, onOpenChange: setIsOpen }, props, { children: [(0, jsx_runtime_1.jsx)(SelectParts_1.Select.Trigger, { className: "*:first:min-w-(--label-length)", style: { '--label-length': `${String(props.items.length).length}ch` } }), (0, jsx_runtime_1.jsx)(SelectParts_1.Select.Popup, { popupRef: handleScrollElementRef, className: "h-[min(22rem,var(--total-scroll-element-height))]", style: { '--total-scroll-element-height': `${totalScrollElementHeight}px` }, children: (0, jsx_runtime_1.jsx)(SelectParts_1.Select.List, { role: "presentation", className: "relative w-full", style: { height: totalScrollElementHeight }, children: virtualizer.getVirtualItems().map(virtualItem => {
                        const item = props.items[virtualItem.index];
                        if (!item)
                            return null;
                        return ((0, jsx_runtime_1.jsx)(SelectParts_1.Select.Item, { label: item.label, "data-selected": props.value === item.value ? true : undefined, onClick: () => props.onChange(item.value), style: {
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: virtualItem.size,
                                transform: `translateY(${virtualItem.start}px)`,
                            } }, virtualItem.key));
                    }) }) })] })));
};
exports.SelectVirtualized = SelectVirtualized;
